import get from 'lodash/get';

export const suffixByOrigin = origin => {
  switch (parseInt(origin, 10)) {
    case 11:
      return '_adwords'; // SERP (AdWords)
    case 20:
      return '_dsa'; // SERP (AdWords DSA)
    case 13:
      return '_bing'; // SERP (Bing)
    case 54:
      return '_jot'; // SERP (JOT AdWords)
    case 57:
      return '_bing_jot'; // SERP (JOT Bing)
    case 58:
      return '_yandex_jot'; // SERP (JOT Yandex)
    case 22:
      return '_fb_display'; // SERP (FB Display)
    case 4:
      return '_rtb'; // SERP (RTB)
    case 21:
      return '_adwords_display'; // SERP (AdWords Display)
    default:
      return '';
  }
};

export const suffixByABTest = (option, isSem) => {
  const options = ['A', 'B', 'C', 'D', 'E'];
  const position = options.indexOf(option) + 1;

  return isSem ? `_landing_ab_${position}` : `_ab_${position}`;
};

export const adSenseAttributionChannel = ({
  countryCode,
  verticalName,
  isRetention = false,
  isSem = false,
  origin = 0,
  abTest = '',
}) => {
  const channelBaseName = `${countryCode}_${verticalName}`;
  let suffix = '';

  if (isRetention) {
    suffix = '_retention';
  } else if (isSem) {
    suffix = suffixByOrigin(origin);
  }

  if (abTest) {
    const testAbSuffix = suffixByABTest(abTest, isSem);

    return `${channelBaseName}${suffix},${channelBaseName}${testAbSuffix}`;
  }

  return `${channelBaseName}${suffix}`;
};

export const getAdUnit = (countryCode, verticalName, isSemUrl, isRetentionUrl) => {
  let suffix;

  if (isSemUrl) {
    suffix = 'landing';
  } else if (isRetentionUrl) {
    suffix = 'retention';
  } else {
    suffix = 'serp';
  }

  return `${countryCode.toUpperCase()}_${verticalName.toUpperCase()}/MOB-WEB-${suffix}`;
};

export const formatCustomTargetingObject = ({
  trovit,
  config,
  searchParameters,
  adPageType = '',
}) => {
  const appEnvironment = get(config, ['env', 'appEnvironment']);
  const verticalName = config.verticalName;
  const isDevel = appEnvironment === 'production' || appEnvironment === 'staging' ? 0 : 1;

  let verticalSpecificParams;
  if (verticalName === 'homes') {
    verticalSpecificParams = {
      new_build: get(searchParameters, ['filters', 'new_build']) || '',
      parking: get(searchParameters, ['filters', 'parking']) || '',
      property_type: get(searchParameters, ['filters', 'property_type']) || '',
    };
  } else if (verticalName === 'cars') {
    verticalSpecificParams = {
      make: get(searchParameters, ['filters', 'make']) || '',
      model: get(searchParameters, ['filters', 'model']) || '',
    };
  }
  return {
    country: config.countryCode || '',
    vertical: config.verticalName || '',
    devel: isDevel,
    origin: trovit.origin || '',
    query: get(searchParameters, 'what_d') || '',
    type: get(searchParameters, 'type_id') || 1,
    price_min: get(searchParameters, ['filters', 'price_min']) || '',
    price_max: get(searchParameters, ['filters', 'price_max']) || '',
    city: get(searchParameters, ['filters', 'city']) || '',
    region: get(searchParameters, ['filters', 'region']) || '',
    atomicPageType: adPageType,
    ...verticalSpecificParams,
  };
};
// Only for jobs
// category
// q_what
// q_where



// WEBPACK FOOTER //
// ./app/utils/adSense.js